import React, { useMemo } from 'react';

import { HoverPreloader } from '@confluence/hover-preloader';

import { useEditorBreadcrumbs } from '../hooks/useEditorBreadcrumbs';
import { getClosePreloadUrl, getPublishPreloadUrl } from '../utils';

export const PreloadButtonWrapper = ({
	isPublish,
	contentId,
	spaceKey,
	contentType,
	isUnpublishedDraft,
	children,
}: {
	isPublish: boolean;
	contentId: string;
	spaceKey: string;
	contentType: string;
	isUnpublishedDraft: boolean;
	children: React.ReactNode;
}) => {
	const breadcrumbs = useEditorBreadcrumbs(contentId);
	const publishPreloadUrl = getPublishPreloadUrl({
		contentId,
		spaceKey,
		contentType,
	});
	const closePreloadUrl = useMemo(() => {
		if (!breadcrumbs || breadcrumbs.length === 0) {
			return '';
		}
		return getClosePreloadUrl({
			contentId,
			spaceKey,
			contentType,
			breadcrumbs,
			isUnpublishedDraft,
		});
	}, [contentId, spaceKey, contentType, isUnpublishedDraft, breadcrumbs]);

	return (
		<HoverPreloader preloadUrl={isPublish ? publishPreloadUrl : closePreloadUrl}>
			{children}
		</HoverPreloader>
	);
};
